/* Desktop hover enhancement; native Dawn click/keyboard behavior is preserved. */
(() => {
  if (window.ape13HoverMenuLoaded) return;
  window.ape13HoverMenuLoaded = true;
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const initialized = new WeakSet();
  function initialize(root = document) {
    root.querySelectorAll('details.ape-menu').forEach(menu => {
      if (initialized.has(menu)) return;
      initialized.add(menu);
      let timer;
      const summary = menu.querySelector(':scope > summary');
      const setOpen = open => {
        menu.open = open;
        summary?.setAttribute('aria-expanded', String(open));
      };
      menu.addEventListener('pointerenter', event => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        clearTimeout(timer);
        // Keep only one desktop panel open, including other native Dawn menus.
        menu.closest('nav')?.querySelectorAll('header-menu > details[open]').forEach(other => {
          if (other === menu) return;
          other.open = false;
          other.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        });
        setOpen(true);
      });
      menu.addEventListener('pointerleave', event => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        clearTimeout(timer);
        timer = setTimeout(() => {
          // Do not close a panel while a keyboard user is navigating its links.
          if (!menu.contains(document.activeElement)) setOpen(false);
        }, 180);
      });
      menu.addEventListener('focusin', () => clearTimeout(timer));
      menu.addEventListener('focusout', () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!menu.contains(document.activeElement) && !menu.matches(':hover')) setOpen(false);
        }, 180);
      });
      // Dawn retains Escape handling; synchronize state after native toggles.
      menu.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(menu.open)));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
